module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Cotización")])]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "Nombre",
      "label": "Nombre"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarcliente($event)
      }
    },
    model: {
      value: (_vm.cliente.cliente),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "cliente", $$v)
      },
      expression: "cliente.cliente"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0307702c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ccliente.vue
// module id = 424
// module chunks = 1